import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '@/features/shared/utils/sessionStorage'

export const getAmplitudeSession = () => {
  const now = Date.now()
  const existingSessionEpoch = Number(getSessionStorageItem('shipt_amplitude_session'))
  const isExpired = now - new Date(existingSessionEpoch).getTime() > 1800000
  // reset session if doesn't exist or >30 minutes
  if (isExpired) {
    setSessionStorageItem('shipt_amplitude_session', now.toString())
    return now
  }
  return existingSessionEpoch
}

// support cloud-mode for Amplitude: https://segment.com/docs/connections/destinations/catalog/amplitude/#sessionid
export const addCloudModeIntegrations = () => ({
  Amplitude: {
    session_id: getAmplitudeSession(),
  },
})
